import Swiper from 'swiper/swiper-bundle.min'
import {initHiddenImages} from '@/app/js/hidden-images'

export function initSwipers() {
  initHistorySwiper()
  initProductSwiper()
  initCompanySwiper()
  initReviewSwiper()
  initMainCarousel()
  initOffersSwiper()
}

function initHistorySwiper() {
  const swiperEl = document.querySelector('.js-swiper-history')

  if (!swiperEl) return

  new Swiper(swiperEl, {
    autoplay: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
}

function initProductSwiper() {
  const swiperEl = document.querySelector('.js-swiper-product')

  if (!swiperEl) return

  const productSwiper = new Swiper(swiperEl, {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  const thumbsEl = document.querySelector('.js-product-thumbs')

  initHiddenImages(thumbsEl)

  window.activeProductThumb = document.querySelector('.js-product-thumbs .active')

  productSwiper.on('slideChange', () => {
    const thumbEl = document.querySelector('label[data-thumb-id="' + productSwiper.activeIndex + '"]')
    window.activeProductThumb.classList.remove('active')
    window.activeProductThumb = thumbEl
    thumbEl.classList.add('active')
  })

  const allThumbs = document.querySelectorAll('label[data-thumb-id]')
  for (const thumbEl of allThumbs) {
    thumbEl.addEventListener('click', () => {
      productSwiper.slideTo(Number(thumbEl.dataset.thumbId))
    })
  }
}

function initCompanySwiper() {
  const swiperEl = document.querySelector('.js-company-slider')

  if (!swiperEl) return

  new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      380: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 40
      }
    }
  })
}

function initReviewSwiper() {
  const swiperEl = document.querySelector('.js-review-slider')

  if (!swiperEl) return

  new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  })
}

function initOffersSwiper() {
  const swiperEl = document.querySelector('.js-offers-slider')

  if (!swiperEl) return

  new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      650: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  })
}

function initMainCarousel() {
  const swiperEl = document.querySelector('.js-main-carousel')

  if (!swiperEl) {
    return
  }

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  let isSubmitting = false

  function stopAutoplay() {
    swiper.autoplay.stop()
    swiper.autoplay.paused = true
  }

  function startAutoplayIfAllowed() {
    const activeEl = document.activeElement
    const isFieldFocused = activeEl && swiperEl.contains(activeEl) && activeEl.matches('input, textarea, select')

    if (isSubmitting || isFieldFocused) {
      return
    }

    swiper.autoplay.start()
    swiper.autoplay.paused = false
  }

  swiperEl.addEventListener('ajax-form:submit-start', () => {
    isSubmitting = true
    stopAutoplay()
  })

  swiperEl.addEventListener('ajax-form:submit-end', () => {
    isSubmitting = false
    startAutoplayIfAllowed()
  })

  swiperEl.querySelectorAll('input, textarea, select').forEach(item => {
    item.addEventListener('focus', stopAutoplay)
    item.addEventListener('blur', startAutoplayIfAllowed)
  })

}
